import {
	argentinaMKId,
	brazilMKId,
	canadaMKId,
	colombiaMKId,
	getStoreId,
	peruMKId,
	spainMKId,
	suiteMKId,
	usMKId,
	russiaMKId,
	ukMKId,
	portugalMKId,
	polandMKId,
	lithuaniaMkId,
	slovakiaMKId,
	testMKId,
	moldovaMKId,
	czechMKId,
	globalMKId,
} from './StoreConfigManager.js';

export const isGlobalMKIdStore = getStoreId() === globalMKId;

const variables = require('../../../variables/Variables.js');
const apiUrl = variables.apiUrl;

function getStaticUrlAsync(id) {
	const fetchUrl = apiUrl + 'asset/url?id=' + id;
	return new Promise((resolve, reject) => {
		fetch(fetchUrl)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				} else {
					throw new Error(
						'Fetch static asset url failed with code ' +
						response.status,
					);
				}
			})
			.then((responseJson) => resolve(responseJson))
			.catch((error) => reject(error));
	});
}

export const NavMarkerSpriteName = Object.freeze({
	NORMALLEFT: 'NavMarkerNormalLeft',
	NORMALRIGHT: 'NavMarkerNormalRight',
	NORMALUP: 'NavMarkerNormalUp',
	NORMALDOWN: 'NavMarkerNormalDown',
	NORMALUPLEFT: 'NavMarkerNormalUpLeft',
	NORMALDOWNLEFT: 'NavMarkerNormalDownLeft',
	NORMALUPRIGHT: 'NavMarkerNormalUpRight',
	NORMALDOWNRIGHT: 'NavMarkerNormalDownRight',
	NORMALSTAIRSUP: 'NavMarkerNormalStairsUp',
	NORMALSTAIRSDOWN: 'NavMarkerNormalStairsDown',
	HOVERLEFT: 'NavMarkerHoverLeft',
	HOVERRIGHT: 'NavMarkerHoverRight',
	HOVERUP: 'NavMarkerHoverUp',
	HOVERDOWN: 'NavMarkerHoverDown',
	HOVERUPLEFT: 'NavMarkerHoverUpLeft',
	HOVERDOWNLEFT: 'NavMarkerHoverDownLeft',
	HOVERUPRIGHT: 'NavMarkerHoverUpRight',
	HOVERDOWNRIGHT: 'NavMarkerHoverDownRight',
	HOVERSTAIRSUP: 'NavMarkerHoverStairsUp',
	HOVERSTAIRSDOWN: 'NavMarkerHoverStairsDown',
	FADELEFT: 'NavMarkerFadeLeft',
	FADERIGHT: 'NavMarkerFadeRight',
	FADEUP: 'NavMarkerFadeUp',
	FADEDOWN: 'NavMarkerFadeDown',
	FADEUPLEFT: 'NavMarkerFadeUpLeft',
	FADEDOWNLEFT: 'NavMarkerFadeDownLeft',
	FADEUPRIGHT: 'NavMarkerFadeUpRight',
	FADEDOWNRIGHT: 'NavMarkerFadeDownRight',
	FADESTAIRSUP: 'NavMarkerFadeStairsUp',
	FADESTAIRSDOWN: 'NavMarkerFadeStairsDown',
});

export function getHeartFillUrlAsync() {
	return getStaticUrlAsync('HeartFill');
}

export function getHeartEmptyUrlAsync() {
	return getStaticUrlAsync('HeartEmpty');
}

export function getNavMarkerUrlAsync(spriteName) {
	return getStaticUrlAsync(spriteName);
}

export function getProductMarkerNormalAsync() {
	return getStaticUrlAsync('ProductMarkerNormal');
}

export function getProductMarkerHoverAsync() {
	return getStaticUrlAsync('ProductMarkerHover');
}

export function getVideoMarkerNormalAsync() {
	return getStaticUrlAsync('VideoMarkerNormal');
}

export function getModalCloseIconNormalAsync() {
	return getStaticUrlAsync('ModalCloseIconNormal');
}

export function getModalCloseIconHoverAsync() {
	return getStaticUrlAsync('ModalCloseIconHover');
}

export function getDragToSpinAsync() {
	return getStaticUrlAsync('DragToSpin');
}

export function getDragToSpinIconAsync() {
	return getStaticUrlAsync('DragToSpinIcon');
}

export function getFacebookAsync() {
	return getStaticUrlAsync('FacebookIcon');
}

export function getTwitterAsync() {
	return getStaticUrlAsync('TwitterIcon');
}

export function getVideoPlayAsync() {
	return getStaticUrlAsync('VideoPlay');
}

export function getObsessLogoAsync() {
	return getStaticUrlAsync('ObsessLogo');
}

export function getObsessUrlAsync() {
	return getStaticUrlAsync('ObsessUrl');
}

export function getWelcomeExploreUrlAsync() {
	return getStaticUrlAsync('WelcomeExplore');
}

export function getZoomIconUrlAsync() {
	return getStaticUrlAsync('ZoomIcon');
}

export function getWelcomeTooltipRoomId() {
	let roomId = '';
	switch (getStoreId()) {
		case brazilMKId:
			roomId = '601c937dab4ee716dcf355eb';
			break;
		case argentinaMKId:
			roomId = '601c753cc1b4f781a3d1ecc3';
			break;
		case spainMKId:
			roomId = '601c98c30ee30d97e17d0d60';
			break;
		case colombiaMKId:
			roomId = '601c8caf41ccb9a58fd1ecc9';
			break;
		case peruMKId:
			roomId = '601c6c1b0f46e2d59134954e';
			break;
		case canadaMKId:
			roomId = '601cdab02b35d36bc77a9fbd';
			break;
		case usMKId:
			roomId = '601cc750449801b39ed3b381';
			break;
		case suiteMKId:
			roomId = '5f5150fb1f2c164d4c0ac1b1';
			break;
		case russiaMKId:
			roomId = '610c7a559ed97ea76b08dde8';
			break;
		case ukMKId:
			roomId = '610dabc09ed97ea76b08e016';
			break;
		case portugalMKId:
			roomId = '6195533b9b96c033d8169c2e';
			break;
		case polandMKId:
			roomId = '620537c4c38181ef4d34f861';
			break;
		case lithuaniaMkId:
			roomId = '624737272b074254a36befc6';
			break;
		case slovakiaMKId:
			roomId = '624f6fc82b074254a36c0f27';
			break;
		case testMKId:
			roomId = '6010c7f4f651ebafdac5912a';
			break;
		case moldovaMKId:
			roomId = '624f089e2b074254a36bffa5';
			break;
		case czechMKId:
			roomId = '624f3a922b074254a36c0552';
			break;
		case globalMKId:
			roomId = '62f54ccf174b1a3ffe7d7029';
		default:
			break;
	}
	return roomId;
}

// offset views
export const customViewOffsetIds = Object.freeze({
	// Portugal
	//satin-spa-wall
	'6195533b9b96c033d8169c67': {
		leftAngle: 66,
		upAngle: 0.01,
	},
});
